import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin.guard';
import { NoAccessComponent } from './pages/no-access/no-access.component';
import { BulkUpload360Component } from './pages/bulk-upload-360/bulk-upload-360.component';
import { MapsComponent } from './pages/maps/maps.component';
import { FleetComponent } from './pages/fleet/fleet.component';
import { FleetReportsComponent } from './pages/fleet-reports/fleet-reports.component';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  {
    path: 'no-access',
    component: NoAccessComponent,
    data: { showShell: false }
  },
  {
    path: '',
    canActivate: [adminGuard],
    children: [
      { path: '', pathMatch: 'full', component: HomeComponent, data: { showShell: false } },
      {
        path: '360-bulk-upload',
        component: BulkUpload360Component
      },
      {
        path: 'maps',
        canActivate: [adminGuard],
        component: MapsComponent
      },
      {
        path: 'fleet',
        canActivate: [adminGuard],
        component: FleetComponent
      },
      {
        path: 'fleet-reports/:agentId',
        canActivate: [adminGuard],
        component: FleetReportsComponent
      }
    ]
  },
  { path: '**', redirectTo: '' }
];
